var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResponse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 38.6667C32.1525 38.6667 39.1667 31.6525 39.1667 23C39.1667 14.3475 32.1525 7.33333 23.5 7.33333C14.8475 7.33333 7.83333 14.3475 7.83333 23C7.83333 31.6525 14.8475 38.6667 23.5 38.6667ZM23.5 46C36.2026 46 46.5 35.7026 46.5 23C46.5 10.2975 36.2026 0 23.5 0C10.7975 0 0.5 10.2975 0.5 23C0.5 35.7026 10.7975 46 23.5 46Z",
    fill: "#FF5000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58984 35.0596L36.9232 6.05957L42.0789 11.2746L12.7456 40.2746L7.58984 35.0596Z",
    fill: "#FF5000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResponse);
export default __webpack_public_path__ + "static/media/noResponse.1960793006f0386c2292e822e201c615.svg";
export { ForwardRef as ReactComponent };